<div class="callback-container">
  <div class="callback-content">
    <img src="./assets/favicons/cropped-explain-favicon-192x192.png" alt="Explain" width="48" height="48" />
    @if (processing) {
      <h3>{{ 'crm.callback.processing' | translate }}</h3>
    }
    @if (!processing && status === 'success') {
      <h3>{{ 'crm.callback.success' | translate }}</h3>
    }
    @if (!processing && status === 'error') {
      <h3>{{ 'crm.callback.error' | translate }}</h3>
    }
    @if (processing) {
      <div class="spinner"></div>
    }
    @if (!processing && status === 'error' && errorMessage) {
      <div class="error-text">{{ errorMessage }}</div>
    }
    @if (!processing) {
      <div class="hint">{{ 'crm.callback.hint' | translate }}</div>
    }
  </div>
</div>
